const API_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Fire-and-forget analytics event. Silent on failure — analytics never
 * blocks the UX. Stores only {kind, contentId?, sourceContext?, reasonKey?}
 * server-side, never journal text or moods (moods live in their own
 * server-side check-in flow).
 */
export const trackEvent = (kind, meta = {}) => {
  try {
    const token = localStorage.getItem('rbr_token');
    if (!token) return;
    fetch(`${API_URL}/api/analytics/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({
        kind,
        contentId: meta.contentId || null,
        sourceContext: meta.sourceContext || null,
        reasonKey: meta.reasonKey || null,
      }),
      keepalive: true,
    }).catch(() => {});
  } catch { /* ignore */ }
};

export default trackEvent;
